import * as React from 'react'
import { AttachmentParams } from '../types'
import Badge from 'material-ui/Badge'

interface UploadedImagesProps {
  key: string
  file: AttachmentParams
  index: number
  isBadgeNeeded: boolean
  handleIconClick: (event: any) => void
  handleImageRemoval?: (id: string) => void
}

interface UploadedImagesState {
  file: AttachmentParams
}

export default class UploadedImages extends React.Component<UploadedImagesProps, UploadedImagesState> {

  onKeyDown = (e: any, id: string) => {
    if (e.key === ' ' || e.key === 'Enter') {
      this.props.handleIconClick(e)
    }
    if (e.key === 'Delete') {
      this.props.handleImageRemoval && this.props.handleImageRemoval(id)
    }
  }

  handleImageRemoval = (id) => {
    this.props.handleImageRemoval && this.props.handleImageRemoval(id)
  }

  render() {
    let file = this.props.file
    let src = file.base64 && file.base64 !== '' ? file.base64 : file.url

    return (
      <label className="show-uploaded-file">
        {
          this.props.isBadgeNeeded ?
            <Badge
              badgeContent={
                <div
                  className="delete-icon"
                  // tslint:disable-next-line:jsx-no-lambda
                  onClick={() => this.handleImageRemoval(file.id)}
                  id={file.id}
                />
              }
              className="badge-img"
            >
              <div
                id={this.props.index.toString()}
                onClick={this.props.handleIconClick}
                // tslint:disable-next-line:jsx-no-lambda
                onKeyDown={(e) => this.onKeyDown(e, file.id)}
                style={{
                  backgroundImage: 'url(' + src + ')',
                  backgroundPosition: 'center center',
                  backgroundRepeat: 'no-repeat',
                  backgroundSize: 'cover'
                }}
                className="image-loader"
                tabIndex={0}
              />
            </Badge>
            :
            <div
              id={this.props.index.toString()}
              onClick={this.props.handleIconClick}
              style={{
                backgroundImage: 'url(' + src + ')',
                backgroundPosition: 'center center',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover'
              }}
              className="image-loader"
              tabIndex={-1}
            />
        }
      </label>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/UploadedImages.tsx